import { useState } from "react";
import axios from "axios";

const gold = "#c8a96e";

export default function Analyzer() {
  const [domain, setDomain] = useState("");
  const [result, setResult] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  async function analyze() {
    if (!domain.trim()) return;
    setLoading(true);
    setResult("");
    setError("");
    try {
      const { data } = await axios.post("/api/ai/analyze", { domain });
      setResult(data.result);
    } catch (err) {
      setError(err.response?.data?.error || "حدث خطأ في الاتصال");
    }
    setLoading(false);
  }

  return (
    <div>
      <p style={{ color: "#666", fontSize: 13, marginBottom: 20 }}>
        أدخل اسم دومين وسأحلله لك من جميع الجوانب فوراً
      </p>
      <div style={{ display: "flex", gap: 10, marginBottom: 24 }}>
        <input value={domain} onChange={(e) => setDomain(e.target.value)}
          onKeyDown={(e) => e.key === "Enter" && analyze()}
          placeholder="example.com"
          style={{ flex: 1, background: "rgba(255,255,255,0.06)", border: "1px solid rgba(255,255,255,0.12)", borderRadius: 10, padding: "13px 16px", color: "#fff", fontSize: 14, outline: "none", direction: "ltr", fontFamily: "inherit" }} />
        <button onClick={analyze} disabled={loading}
          style={{ background: loading ? "#333" : gold, color: "#0f0d0a", border: "none", borderRadius: 10, padding: "13px 20px", fontWeight: 700, cursor: loading ? "not-allowed" : "pointer", fontSize: 13, whiteSpace: "nowrap" }}>
          {loading ? "..." : "حلّل ◉"}
        </button>
      </div>
      {loading && (
        <div style={{ textAlign: "center", padding: "40px 0" }}>
          <div style={{ color: gold, fontSize: 32, marginBottom: 12 }}>◉</div>
          <div style={{ color: "#666", fontSize: 13 }}>جارٍ تحليل الدومين...</div>
        </div>
      )}
      {error && <div style={{ background: "rgba(196,124,124,0.1)", border: "1px solid rgba(196,124,124,0.3)", borderRadius: 10, padding: 14, color: "#c47c7c", fontSize: 13 }}>{error}</div>}
      {result && (
        <div style={{ background: "rgba(255,255,255,0.04)", border: "1px solid rgba(200,169,110,0.2)", borderRadius: 16, padding: 20 }}>
          <div style={{ color: gold, fontSize: 11, letterSpacing: 2, marginBottom: 14 }}>نتيجة التحليل — {domain}</div>
          <div style={{ color: "#ddd", fontSize: 14, lineHeight: 2, whiteSpace: "pre-wrap" }}>{result}</div>
        </div>
      )}
    </div>
  );
}
